import { useContext } from "react";
import ModalAutoT from "_+_Portal/_-_Autocheckin/components/genericos/ModalAutoT/ModalAutoT";
import {
  setCentroId,
  wsGetCentros,
} from "_+_Portal/_-_Autocheckin/context/action/atencionSinTurno";
import { setPaso } from "_+_Portal/_-_Autocheckin/context/action/paso";
import { setUbicacion } from "_+_Portal/_-_Autocheckin/context/action/ubicacion";
import { AutocheckContext } from "_+_Portal/_-_Autocheckin/context/Provider";
import { EstaEnDim } from "../PagesFun";
import {
  LocationErrorType,
  buildLocationErrorPresentation,
  obtenerUbicacionActual,
} from "global/utils/GpsLocation";

const UbicacionSinTurno = ({ setLoading, setError }) => {
  // -------------------------  context ----------------------------
  const { pasoDispatch, pasoState, atencionSinTurnoDispatch, ubicacionDispatch } =
    useContext(AutocheckContext);
  // -------------------------  context ----------------------------

  // -------------------------  MOCK CONFIG ----------------------------
  const MOCK_UBICACION = false; // DESACTIVADO - usar datos reales
  const MOCK_CENTRO_1 = { latitud: -34.642033, longitud: -58.566113 }; // DIM Belgrano (idCentro: 1)
  const MOCK_CENTRO_2 = { latitud: -34.635800, longitud: -58.527600 }; // DIM Espora (idCentro: 2)
  const MOCK_CENTRO_3 = { latitud: -34.652700, longitud: -58.619800 }; // DIM Morón (idCentro: 3)
  const MOCK_CENTRO = MOCK_CENTRO_3; // Usar DIM Morón
  // -------------------------  MOCK CONFIG ----------------------------

  // -------------------------  funciones ----------------------------
  const handleClickOne = async () => {
    // const ubicacionGuardada = getItemWithExpiry("ubicacion");
    // if (ubicacionGuardada) {
    //   if (pasoState.circuito === "turnos") {
    //     setPaso("TurnosDelDia")(pasoDispatch);
    //   } else if (pasoState.circuito === "ordenes") {
    //     setPaso("OrdenesDigitales")(pasoDispatch);
    //   } else if (pasoState.circuito === "turnosLabo") {
    //     setPaso("TurnosDelDiaLabo")(pasoDispatch);
    //   }
    //   return;
    // }
    setLoading("Cargando...");

    try {
      const ubicacion = MOCK_UBICACION 
        ? MOCK_CENTRO 
        : await obtenerUbicacionActual();
      setUbicacion({ latitud: ubicacion.latitud, longitud: ubicacion.longitud })(ubicacionDispatch);

      if (pasoState.circuito === "turnos") {
        setPaso("TurnosDelDia")(pasoDispatch);
      } else if (pasoState.circuito === "ordenes") {
        setPaso("OrdenesDigitales")(pasoDispatch);
      } else if (pasoState.circuito === "turnosLabo") {
        setPaso("TurnosDelDiaLabo")(pasoDispatch);
      } else {
        wsGetCentros((isCorrect, data) =>
          nextStepCentros(isCorrect, data, ubicacion)
        )(atencionSinTurnoDispatch);
      }
    } catch (err) {
      const errorType = err?.errorType || LocationErrorType.UNKNOWN;
      console.error(
        "[UbicacionSinTurno] Error al obtener ubicación:",
        errorType,
        err?.message || err
      );
      setError({
        ...buildLocationErrorPresentation(errorType),
        errorBack: "Home",
      });
      setPaso("ModalErrorAutoT")(pasoDispatch);
    }
    // } else {
    //   setCentroId([ubicacionGuardada])(atencionSinTurnoDispatch);
    //   setPaso("DemandaEspontanea")(pasoDispatch);
    // }
  };

  const nextStepCentros = (isCorrect, centros, ubicacion) => {
    if (isCorrect) {
      const location = EstaEnDim(
        ubicacion.latitud,
        ubicacion.longitud,
        centros
      );
      if (location) {
        setCentroId([location])(atencionSinTurnoDispatch);
        setPaso("DemandaEspontanea")(pasoDispatch);
      } else {
        setError({
          message: "No se encuentra en un centro DIM válido",
          errorBack: "Home",
        });
        setPaso("ModalErrorAutoT")(pasoDispatch);
      }
    } else {
      setError({
        message: "No se han podido obtener los centros",
        errorBack: "Home",
      });
      setPaso("ModalErrorAutoT")(pasoDispatch);
    }
  };

  const handleClickTwo = () => {
    setPaso("Home")(pasoDispatch);
  };

  // -------------------------  funciones ----------------------------

  return (
    <ModalAutoT
      title={`¿Usted se encuentra en DIM? `}
      desc={`
      Le solicitamos está información para que usted pueda realizar los siguientes tramites
  `}
      textBtnOne={"SI"}
      textBtnTwo={"NO"}
      handleChange={{ btnOne: handleClickOne, btnTwo: handleClickTwo }}
    />
  );
};

export default UbicacionSinTurno;
